import store from '../store'
/**
 * 判断用户是否拥有按钮操作权限
 * 根据传入的权限功能key，
 * @param {String} key
 * @returns
 */
export function checkFunction(key) {
  const functionList = store.getters.functionKey
  const index = functionList.indexOf(key)
  if (index > -1) {
    return true // 有权限
  } else {
    return false // 无权限
  }
}

export default {
  checkFunction
}
